module.exports = __webpack_public_path__ + "img/121ne.31be120f.svg";